<template>
<div id="frame">
  <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <card :title="title" :subTitle="subtitle" v-if="tick === 1" id="frame">
      <v-text-field
        v-model="date"
        label="Datum"
        type="date"
        :readonly="canModify"
      ></v-text-field>
      <v-text-field
        v-model="time"
        label="Uhrzeit"
        type="time"
        :readonly="canModify"
      ></v-text-field>
      <v-text-field
        v-model="name"
        :error-messages="nameErrors"
        label="Ihr Name"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
        required
        clearable
        @click:clear="clearName()"
      ></v-text-field>
      <v-container v-if="Number(this.$route.params.bereichID) === 1" style="padding: 0">
      <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
          <v-list-tile>
            <v-list-tile-action>
              <v-checkbox v-model="checkPoint.check"></v-checkbox>
            </v-list-tile-action>
            <div @click="checkPoint.check = !checkPoint.check" class="pointer">
              {{checkPoint.text}}
            </div>
          </v-list-tile>
          <v-divider/>
        </div>
      </v-container>
      <v-container v-if="Number(this.$route.params.bereichID) === 2" style="padding: 0">
        <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
          <v-list-tile v-if="checkPoint.dayCheck.includes(weekDay)">
            <v-list-tile-action>
              <v-checkbox v-model="checkPoint.check"></v-checkbox>
            </v-list-tile-action>
            <div @click="checkPoint.check = !checkPoint.check" class="pointer">
              {{checkPoint.text}}
            </div>
          </v-list-tile>
          <v-divider v-if="checkPoint.dayCheck.includes(weekDay)" />
        </div>
      </v-container>
      <v-container v-if="[3, 4].includes(Number(this.$route.params.bereichID))" style="padding: 0">
        <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
          <v-list-tile>
            <v-list-tile-action>
              <v-checkbox v-model="checkPoint.check"></v-checkbox>
            </v-list-tile-action>
            <div @click="checkPoint.check = !checkPoint.check" class="pointer">
              {{checkPoint.text}}
            </div>
          </v-list-tile>
          <v-divider />
        </div>
      </v-container>
      <v-container v-if="needImage" style="padding: 0">
        <div class="picture" v-if="!imageState">
          <label class="custom-file-upload btn btn-sm btn-danger">
            <input type="file" accept="image/*" capture="" @change="onFileChangeImage($event)">
            Foto vom Vorbereitungsraum (Warenannahmen)
          </label>
          <br>
          <p><i class="pictureText">Es wurde noch kein Foto aufgenommen</i></p>
        </div>
        <div class="picture" v-else>
          <button class="btn btn-sm btn-secondary" @click="showImage()" v-if="!showImageBool">Foto anzeigen</button>
          <button class="btn btn-sm btn-secondary" @click="showImage()" v-else>Foto ausblenden</button>
          <span class="buttonMargin"><button class="btn btn-sm btn-danger" @click="removeImage($event)">Foto entfernen</button></span>
          <br>
          <p><i class="pictureText">Foto erstellt.</i></p>
          <div v-if="showImageBool">
            <img :src="image"/>
          </div>
        </div>
      </v-container>
    <v-divider v-if="needImage" />
      <v-text-field
        v-model="bemerkung"
        label="Bemerkung"
        v-on:keyup.enter="nextTick()"
      ></v-text-field>
      <v-divider/>
      <!-- <v-btn @click="submit">submit</v-btn> -->
      <div class="alert alert-danger" id="alert"
        v-if="((needImage && image === '') ||
              (!needImage && name === '')) ||
              (([1, 3, 4].includes(Number(this.$route.params.bereichID)) && this.checkPoints.filter(checkpoint => !checkpoint.check).length > 0) ||
              ([2].includes(Number(this.$route.params.bereichID)) && this.checkPoints.filter(checkpoint => { return checkpoint.dayCheck.includes(this.weekDay) ? !checkpoint.check : ''; }).length > 0))">
        <!-- Erfoglsmeldung -->
        <span> F&uuml;r die Best&auml;tigung fehlt:</span>
        <span v-if="name === ''"><br>Name</span>
        <span v-if="needImage && image === ''"><br>Foto</span>
        <span v-if="([1, 3, 4].includes(Number(this.$route.params.bereichID)) && this.checkPoints.filter(checkpoint => !checkpoint.check).length > 0) ||
                    ([2].includes(Number(this.$route.params.bereichID)) && this.checkPoints.filter(checkpoint => { return checkpoint.dayCheck.includes(this.weekDay) ? !checkpoint.check : ''; }).length > 0)"><br>Checkbox</span>
      </div>
      <button class="btn btn-lg btn-danger float-left" v-on:click="goBack('firstCancel')" type="button">abbrechen</button>  
      <button class="btn btn-lg btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
    </card>

    <card :title="title2" v-if="tick === 2" id="frame">
      <hr>
      <!-- bestätigen --> 
      <div class="angaben">
        <p class="messstelle">{{title}}</p>
        <p>Datum: {{formatDate(date)}}</p>
        <p>Uhrzeit: {{time}}</p>
        <p>Ihr Name: {{name}}</p>
        <p>Bemerkung: {{bemerkung}}</p>
      </div>
      <hr>
      <button class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>
      <button class="btn btn-lg btn-success float-right" v-on:click="save()" type="button">bestätigen</button>
    </card>

    <div class="alert alert-success" v-if="!showOfflineMessage && tick === 3 && !loading" id="alert">
      <!-- Erfoglsmeldung -->
      <button type="button" aria-hidden="true" class="close"></button>
      <span>
      <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
    </div>
    <div v-if="tick === 3 && loading">
      <center>
        Bitte lassen Sie den Bildschirm angeschaltet!
        <br>
        Das Hochladen kann je nach Verbindung bis zu 1 Min. dauern.
        <br>
        <v-progress-circular
          :size="70"
          :width="7"
          color="red"
          indeterminate
        ></v-progress-circular>
      </center>
    </div>
    <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
      </span>
    </div>
    <div class="alert alert-warning" v-if="showOfflineMessage  && tick === 3">
      <!-- <div v-if="tick === 3">
        <span>
          <b>Das Ger&auml;t hat keine Internetverbindung.</b> Versuchen Sie es erneut.
        </span>
        <hr>
        <button class="btn btn-danger" v-on:click="save()" type="button">Wiederholen</button>
      </div> -->
      <div v-if="tick === 3">
        <span>
          <b>Das Ger&auml;t hat keine Internetverbindung. - </b> Die Daten wurden zwischengespeichert.
          <br>
          Bitte laden Sie die angelegten Listen bei bestehen einer Internetverbindung in der
            Reinigungslisten-&Uuml;bersicht hoch.
        </span>
        <hr>
        <button class="btn btn-success" v-on:click="goBack('cancelAdd')" type="button">Best&auml;tigen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { numeric, required} from 'vuelidate/lib/validators';
import store from '../../../../../store/store';
import Compressor from 'compressorjs';

export default {
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
  data () {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      checkPoints:[],
      checkAlert: false,
      canModify: false,
      fotoAlert: false,
      loading: false,
      active: true,
      weekDay: "",

      imageState: false,
      needImage: false,
      showImageBool: false,
      image: "",

      tick: 1,
      title: "Checkliste - ",
      title2: "Angaben bestätigen",
      subtitle: "Neue Checkliste anlegen",
      date: "",
      time:"",
      name: "",
      bemerkung: "",
      showErrorMessage: false,
      showOfflineMessage: false,
      dst:[
        {year: 2019, start: "2019-03-31", ende: "2019-10-27"},
        {year: 2020, start: "2020-03-29", ende: "2020-10-25"},
        {year: 2021, start: "2021-03-28", ende: "2021-10-31"},
        {year: 2022, start: "2022-03-27", ende: "2022-10-30"},
        {year: 2023, start: "2023-03-26", ende: "2023-10-29"},
        {year: 2024, start: "2024-03-31", ende: "2024-10-27"},
        {year: 2025, start: "2025-03-30", ende: "2025-10-26"},
        {year: 2026, start: "2026-03-29", ende: "2026-10-25"},
        {year: 2027, start: "2027-03-28", ende: "2027-10-31"},
        {year: 2028, start: "2028-03-26", ende: "2028-10-29"},
        {year: 2029, start: "2029-03-25", ende: "2029-10-28"}
      ],
    }
  },
  methods: {
    deleteFile(index) {
      if(imageState) {
        this.checkPoints[index].image = '';
        this.checkPoints[index].imageState = false;
      }
    },
    showImage() {
      this.showImageBool = !this.showImageBool;
    },
    onFileChangeImage(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }
      Promise.resolve(this.compressImage(files[0])).then((value) => {
        this.createImage(value);
      });
    },
    compressImage(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.6,
          success: (result) => {
            resolve(new File([result], file.name, {type: result.type}));
          }, error: (error) => reject(error)
        });
      })
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
      this.imageState = true;
    },
    removeImage(e) {
      this.image = '';
      this.imageState = false;
    },
    goBack(index) {
      if (index < 0) {
        this.$router.go(index);
      } else if (index === 'cancelAdd') {
        this.$router.go(-1);
      } else if (index === 'firstCancel') {
        this.$router.push({path: '/qs/servicelisten/checklists/' + this.$route.params.bereichID});
      }
    },
    disableNotification() {
      this.showErrorMessage = false;
    },
    nextTick() {
      this.$v.$touch();
      if (Number(this.$route.params.bereichID) === 1) {
        if (!this.$v.$invalid && this.imageState) {
          this.checkPoints.filter(checkpoint => !checkpoint.check).length > 0 ? this.checkAlert = true : this.tick += 1;
        }
      } else if (Number(this.$route.params.bereichID) === 2) {
        if (!this.$v.$invalid) {
          this.checkPoints.filter(checkpoint => {
            return checkpoint.dayCheck.includes(this.weekDay) ? !checkpoint.check : '';
          }).length > 0 ? this.checkAlert = true : this.tick += 1;
        }
      } else if ([3, 4].includes(Number(this.$route.params.bereichID))) {
        if (!this.$v.$invalid) {
          this.checkPoints.filter(checkpoint => !checkpoint.check).length > 0 ? this.checkAlert = true : this.tick += 1;
        }
      }
    },
    cancel(){
      this.tick = 1;
    },
    formatDate(date){
      var today = new Date(date);
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = dd+ '.' + mm + '.' + yyyy;
      return date;
    },
    createToday(){
      var today = new Date();
      this.weekDay = today.getDay();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = yyyy+ '-' + mm + '-' + dd;
      this.date = date;

      //DST check
      var thisYear= yyyy;
      var dstEnd;
      var dstStart;
      for (var i =0; i < this.dst.length; i++){
        if(this.dst[i].year == thisYear){
          dstEnd =  new Date(this.dst[i].ende);
          dstStart = new Date(this.dst[i].start);
        }
      }
      
      if(new Date(date) < dstEnd && new Date(date) >= dstStart ){
        const tmpHour = (today.getUTCHours()+2) < 10 ? '0' + (today.getUTCHours()+2) : (today.getUTCHours()+2);
        if(+today.getUTCMinutes()<10) {
          this.time = tmpHour+ ':0' + today.getUTCMinutes();
        } else{
          this.time = tmpHour+ ':' + today.getUTCMinutes();
        }
      }else{
        const tmpHour = (today.getUTCHours()+1) < 10 ? '0' + (today.getUTCHours()+1) : (today.getUTCHours()+1);
        if(+today.getUTCMinutes()<10){
          this.time = tmpHour + ':0' + today.getUTCMinutes();
        } else{
          this.time = tmpHour + ':' + today.getUTCMinutes();
        }
      }
    },
    save() {
      this.showOfflineMessage = false;
      this.loading = true;
      this.nextTick();
      let checklist = {};
      if (this.needImage) {
        checklist = {
          bereichID: Number(this.$route.params.bereichID),
          datum: this.date,
          uhrzeit: this.time,
          name: this.name,
          bemerkung: this.bemerkung,
          image: this.image
        };
      } else {
        checklist = {
          bereichID: Number(this.$route.params.bereichID),
          datum: this.date,
          uhrzeit: this.time,
          name: this.name,
          bemerkung: this.bemerkung,
        };
      }
      if (this.$online) {
        this.checkPoints.map((checkPoint, index) => {
          if(checkPoint.check === false){
            checkPoint.check = 0;
            checklist[checkPoint.checkPoint] = checkPoint.check;
          }else{
            checkPoint.check = 1;
            checklist[checkPoint.checkPoint] = checkPoint.check;
          }
        });
        this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/checklist/add', checklist, { headers: {'Authorization': this.auth }})
        .then(function(response) {
          if(response.body.error){
              console.log(response.body.error);
              this.nextTick();
              this.showErrorMessage = true;
              setTimeout(() => this.$router.go(-1), 1500);
            } else {
              this.loading = false;
              setTimeout(() => this.$router.go(-1), 1500);
            }
        });
      } else {
        this.checkPoints.map((checkPoint, index) => {
          if(checkPoint.check === false){
            checkPoint.check = 0;
            checklist[checkPoint.checkPoint] = checkPoint.check;
          }else{
            checkPoint.check = 1;
            checklist[checkPoint.checkPoint] = checkPoint.check;
          }
        });
        this.loading = false;
        this.showOfflineMessage = true;

        if (localStorage.getItem('checklistQS' + this.$route.params.bereichID) !== null) {
          let tmp = JSON.parse(localStorage.getItem('checklistQS' + this.$route.params.bereichID));
          tmp.push(checklist);
          localStorage.setItem('checklistQS' + this.$route.params.bereichID, JSON.stringify(tmp));
        } else {
          localStorage.setItem('checklistQS' + this.$route.params.bereichID, JSON.stringify([checklist]));
        }
      }
    }
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.required && errors.push('Bitte geben Sie Ihren Namen ein')
      return errors
    },
  },
  created: function() {
    this.canModify = !store.state;
    this.createToday();

    this.title += this.$route.query.title.charAt(0).toUpperCase() + this.$route.query.title.slice(1);
    if (Number(this.$route.params.bereichID) === 1) {
      this.needImage = true;
      this.checkPoints = [
      {checkPoint: 'fleischwolf', check: false, text: "Fleischwolf gereinigt"},
      {checkPoint: 'arbeitsgeraete', check: false, text: "Arbeitsgeräte gereinigt"},
      {checkPoint: 'grill', check: false, text: "Grill, Herd und Friteuse gereinigt"},
      {checkPoint: 'arbeitsflaeche', check: false, text: "Arbeitsflächen gereinigt"},
      {checkPoint: 'fussboden', check: false, text: "Fußboden und Abläufe gereinigt"},
      {checkPoint: 'waende', check: false, text: "Wände und Türen gereinigt"},
      {checkPoint: 'theken', check: false, text: "Theken Innenbereich gereinigt"},
      {checkPoint: 'spuelmaschine', check: false, text: "Spülmaschine gereinigt"},
      {checkPoint: 'kuehlhausf', check: false, text: "Kühlhaus Fleisch gereinigt"},
      {checkPoint: 'kuehlhausw', check: false, text: "Kühlhaus Wurst gereinigt"},
      {checkPoint: 'kuehlhausk', check: false, text: "Kühlhaus Käse gereinigt"},
      ];
    } else if (Number(this.$route.params.bereichID) === 2) {
      this.needImage = false;
      this.checkPoints = [
      {checkPoint: 'thekeScheibe', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Thekenscheiben sind geputzt'},
      {checkPoint: 'thekeSchraenke', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Schränke sind an der Frontseite feucht abgewischt'},
      {checkPoint: 'thekeWaagen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Waagen sind feucht abgewischt und desinfiziert'},
      {checkPoint: 'thekeMaterial', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Material wurde aufgefüllt'},
      {checkPoint: 'thekeOfen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Warmhalteofen ist gereinigt'},
      {checkPoint: 'thekeAblage', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablageflächen sind feucht abgewischt und desinfiziert'},
      {checkPoint: 'thekePreis', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Preisschilder sind feucht abgewischt'},
      {checkPoint: 'thekeStecher', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Stecher und die Schneide-Bretter sind gespült'},
      {checkPoint: 'thekeSchuesseln', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Alle Schüsseln nicht benötigten Schüsseln sind gespült und stehen nicht auf der Theke (bitte unter den Tisch räumen)'},
      {checkPoint: 'thekeFleisch', check: false, dayCheck: [6, 0],  text: 'Die Fleischtheke ist ausgeräumt und ausgewischt	(Samstag)'},
      {checkPoint: 'thekeAbfluesse', check: false, dayCheck: [6, 0],  text: 'Die Abflüsse in der Fleischtheke wurden heiss gespült und sind frei (Samstag)'},
      {checkPoint: 'thekeMesser', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Messer & Gehacktes-Stecher sind gereinigt und desinfiziert'},
      {checkPoint: 'thekeHeuer', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Heuer ist gereinigt und desinfiziert'},
      {checkPoint: 'thekeKuehlhaus', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Messer, Gehacktes-Stecher und der Heuer liegen im Kühlhaus'},
      {checkPoint: 'thekeGehackte', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das restliche Gehackte  ist abgeschrieben'},
      {checkPoint: 'thekeRindfleisch', check: false, dayCheck: [6],  text: 'Das hochwertige Rindfleisch wurde mit Schildern vakumiert (Samstag)'},
      {checkPoint: 'thekeLicht', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Licht im Bedienungsbereich ist ausgeschaltet'},
      {checkPoint: 'thekeFehlbons', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Fehlbons sind ins Büro gebracht worden'},
      // Vorbereitungsraum
      {checkPoint: 'vorbSaege', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Säge ist zerlegt und gereinigt'},
      {checkPoint: 'vorbEinfuell', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Einfüllschüssel des Wolfs ist desinfiziert'},
      {checkPoint: 'vorbWolf', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Wolf ist zerlegt, die Einzelteile sind gespült'},
      {checkPoint: 'vorbAufschnitt', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Aufschnittmaschine ist gereinigt und desinfiziert'},
      {checkPoint: 'vorbTisch', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Tisch im Vorbereitungsraum ist gereinigt und desinfiziert'},
      {checkPoint: 'vorbSpuelm', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Spülmaschine ist abgepumpt & innen ausgewischt'},
      {checkPoint: 'vorbSteht', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es steht nichts auf der Spülmaschine'},
      {checkPoint: 'vorbSieb', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Sieb in der Spülmaschine ist gereinigt'},
      {checkPoint: 'vorbKartusche', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Reinigungsprogramm Backofen ist gestartet (Reinigungskartusche)'},
      {checkPoint: 'vorbOfen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Ofen ist von außen feucht abgewischt & desinfiziert'},
      {checkPoint: 'vorbAblauf', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablaufgitter und der Boden sind sauber'},
      {checkPoint: 'vorbTuer', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Tür (Vorbereitung/Verkauf) ist feucht abgewischt'},
      {checkPoint: 'vorbMuell', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Müll ist entsorgt & neue Tüte eingesetzt'},
      // Lager
      {checkPoint: 'lagerLeergut', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Leergut im Lagerraum ist gestapelt'},
      {checkPoint: 'lagerVerraeumt', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Betriebsmittel/Tüten sind alle verräumt'},
      {checkPoint: 'lagerLappen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es hängen keine Lappen/Schürzen/Jacken über dem Geländer'},
      {checkPoint: 'lagerDosen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es befindet sich kein Leergut/ Dosen/Flaschen im Lagerbereich'},
      {checkPoint: 'lagerPappen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es wurden sämtliche Pappen/leere Verpackungen entsorgt'},
      {checkPoint: 'lagerPutzmittel', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es stehe keine Reinigungs-Putzmittel herum'},
      {checkPoint: 'lagerSchleif', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ecke mit der Schleifmaschine ist aufgeräumt (Fleischer)'},
      {checkPoint: 'lagerPC', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablage am PC ist aufgeräumt'},
      {checkPoint: 'lagerFleischer', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablage Edelstahlstisch ist aufgeräumt (Fleischer)'},
      {checkPoint: 'lagerGefegt', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Bereich ist gefegt'},
      {checkPoint: 'lagerBesen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Besen/Schrubber hängen an der Halterung'},
      ];
    } else if (Number(this.$route.params.bereichID) === 3) {
      this.needImage = false;
      this.checkPoints= [
        {checkPoint: 'wurstWare', check: false, text: 'Die Stückware wurde aufgefüllt'},
        {checkPoint: 'wurstMat', check: false, text: 'Das Material wurde aufgefüllt'},
        {checkPoint: 'wurstAnsch', check: false, text: 'Die Anschnitte wurden auf Bleche gepackt'},
        {checkPoint: 'wurstBrett', check: false, text: 'Die Bretter und Messer wurden gereinigt und desinfiziert'},
        {checkPoint: 'wurstAufsch', check: false, text: 'Die Aufschnittmaschine wurde gereinigt und desinfiziert'},
        {checkPoint: 'wurstLose', check: false, text: 'Die lose Wurst, Frikadellen und Würstchen wurden in Tüten gepackt'},
        {checkPoint: 'wurstSalat', check: false, text: 'Die Salate wurden abgedeckt'},
        {checkPoint: 'wurstWaage', check: false, text: 'Die Waagen wurden gereinigt und desinfiziert'},
        {checkPoint: 'wurstAblage', check: false, text: 'Die Ablageflächen der Theke sind feucht abgewischt und desinfiziert'},
        {checkPoint: 'wurstSchrae', check: false, text: 'Die Schränke sind an der Frontseite feucht abgewischt'},
        {checkPoint: 'wurstAblagSch', check: false, text: 'Die Ablageflächen der Schränke sind gereinigt und desinfiziert'},
        {checkPoint: 'wurstMuell', check: false, text: 'Die Müllklappen sind gereinigt'},
        {checkPoint: 'wurstSchink', check: false, text: 'Der Schinken und die Dauerwurst sind foliert auf Bleche gepackt'},
        {checkPoint: 'wurstTonne', check: false, text: 'Die Frischwurst und das Kasseler wurden in die Wursttonne gepackt'},
        {checkPoint: 'wurstTheke', check: false, text: 'Die Wurstheke wurde feucht ausgewischt'},
        {checkPoint: 'wurstEnts', check: false, text: 'Der Müll wurde entsorgt'},
        {checkPoint: 'wurstLicht', check: false, text: 'Das Thekenlicht wurde ausgeschaltet'},
        {checkPoint: 'wurstAbschr', check: false, text: 'Die Abschriften wurden in die Listen eingetragen'},
        {checkPoint: 'wurstUmsae', check: false, text: 'Die Umsätze wurden aufgeschrieben und ins Büro gebracht'},
      ];
    } else if (Number(this.$route.params.bereichID) === 4) {
      this.needImage = false;
      this.checkPoints= [
        {checkPoint: 'kaesePetr', check: false, text: 'Petrella und Antipasti sind abgedeckt'},
        {checkPoint: 'kaeseSchnitt', check: false, text: 'Der Schnittkäse ist abgedeckt'},
        {checkPoint: 'kaeseSorten', check: false, text: 'Die Käsesorten sind ordentlich eingepackt'},
        {checkPoint: 'kaeseEinschw', check: false, text: 'Das Einschweissgerät wurde ausgeschaltet'},
        {checkPoint: 'kaeseLicht', check: false, text: 'Das Licht im Kühlschrank wurde ausgeschaltet'},
        {checkPoint: 'kaeseBretter', check: false, text: 'Die Bretter und Messer wurden gereinigt und desinfiziert'},
        {checkPoint: 'kaeseMasch', check: false, text: 'Die Käsemaschine wurde gereinigt und desinfiziert'},
        {checkPoint: 'kaeseWaage', check: false, text: 'Die Waagen wurden gereinigt und desinfiziert'},
        {checkPoint: 'kaeseAblage', check: false, text: 'Die Ablageflächen der Theke sind feucht abgewischt und desinfiziert'},
        {checkPoint: 'kaeseSchrae', check: false, text: 'Die Schränke sind an der Frontseite feucht abgewischt'},
        {checkPoint: 'kaeseGeraeumt', check: false, text: 'Die Ablagefläche ist aufgeräumt'},
        {checkPoint: 'kaeseAblSchr', check: false, text: 'Die Ablageflächen der Schränke sind gereinigt und desinfiziert'},
        {checkPoint: 'kaeseMuellkl', check: false, text: 'Die Müllklappen sind gereinigt'},
        {checkPoint: 'kaeseMuell', check: false, text: 'Der Müll wurde entsorgt'},
      ];
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#frame{
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;

}
.v-messages__message{
   color: rgb(255, 115, 0);
}
.instruction{
    text-align: center;
    font-weight: bold;
}
.pad{
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px ;
}
.messstelle{
    font-weight: bold;
    font-size: large;
}
.angaben{
font-size: large;
font-weight: bold;
}

.pointer {
  cursor: pointer;
}
.picture {
  padding-left: 70px;
}

.pictureText {
  font-size: 13px;
}

.boldtxt{
  font-weight: bold;
}

input[type="file"] {
    display: none;
}
.custom-file-upload {
    display: inline-block;
    padding: 4px 10px;
    cursor: pointer;
    color: #ffffff;
    border-radius: 0.25rem;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.75;
}

.is--disabled {
  opacity: 0.65;
}
.is--disabled:hover {
  background-color: #cc071e;
}

.buttonMargin {
  margin-left: 5px;
}
img {
  width: 70%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}

</style>

